/** Gemeinsame Typen der API. Module ergänzen eigene Typen in ihren Seiten-Ordnern. */
export type Permission =
  | 'pos.sell' | 'pos.discount' | 'pos.void' | 'pos.history' | 'print.jobs'
  | 'cash.session' | 'cash.movements' | 'cash.view_all' | 'cash.blind_count' | 'cash.money_transfer'
  | 'products.view' | 'products.edit' | 'stock.adjust' | 'products.expiry' | 'products.stock_value'
  | 'purchases.view' | 'purchases.manage'
  | 'reports.view' | 'reports.profit'
  | 'time.clock' | 'time.manage'
  | 'parcels.handle' | 'parcels.manage'
  | 'customers.view' | 'customers.sell_on_account' | 'customers.collect' | 'customers.manage'
  | 'webshop.orders' | 'webshop.manage'
  | 'users.manage' | 'settings.manage' | 'backups.manage' | 'audit.view';

export type Role = 'admin' | 'manager' | 'cashier';

export interface User {
  id: number;
  username: string;
  displayName: string;
  role: Role;
  permissions: Permission[];
  totpEnabled: boolean;
  mustChangePassword: boolean;
}

export interface Features {
  sumup: boolean;
  invoiceAi: boolean;
  offsiteBackup: boolean;
}

export interface Me {
  user: User;
  /** Administrator muss zuerst die vorgeschriebene Zwei-Faktor-Anmeldung einrichten (auth.require_2fa_admin) */
  needs2faSetup?: boolean;
  settings: Record<string, unknown>;
  features: Features;
  serverTime: number;
  businessDate: string;
}

export const ROLE_LABELS: Record<Role, string> = { admin: 'Administrator', manager: 'Filialleitung', cashier: 'Kassierer/in' };
